import { Avatar } from '@dinewise/components';
import type { ImageSources } from '@dinewise/utils/node';
import { getPaymentsUserDisplayName } from '~/utils/get-payments-user-display-name.ts';
import type { SessionUser } from '~/utils/sessions.server.ts';

type PaymentsWelcomeHeaderProps = {
  user: SessionUser;
  avatarImageSources?: ImageSources | null;
  hasUnreadNotifications?: boolean;
};

export const PaymentsWelcomeHeader = ({ user, avatarImageSources }: PaymentsWelcomeHeaderProps) => {
  const displayName = getPaymentsUserDisplayName(user);
  const firstDisplayName = displayName.split(' ')[0];
  const lastDisplayName = ' ';

  return (
    <header className="flex items-center justify-between bg-white px-4 pt-6 pb-5">
      <div className="flex items-center gap-3">
        <Avatar
          firstName={user.firstName || firstDisplayName}
          lastName={user.lastName || lastDisplayName}
          imageSources={avatarImageSources}
          classNames={{
            root: 'size-11 shrink-0',
            fallback: 'bg-ande-black font-sans text-base font-semibold text-white shadow-none',
          }}
        />
        <div>
          <p className="text-ande-gray-500 text-xs leading-5">Welcome back!</p>
          <p className="-mt-1 font-semibold text-ande-black text-sm leading-[21px]">
            {displayName}
          </p>
        </div>
      </div>
    </header>
  );
};
